// utils/typeGuards.ts

import { Broker, Exchange, Gold, Prop } from '@/types/layout/postType';
import { LayoutProps } from '@/types/generalSettings';
// Type guard to check if the connected object is Broker, Exchange, or Prop
export const isBrokerExchangeOrProp = (
    connectedObject: LayoutProps.ConnectedObject | undefined,
): connectedObject is Broker | Exchange | Prop | Gold => {
    return (
        connectedObject?.contentTypeName === 'broker' ||
        connectedObject?.contentTypeName === 'exchange' ||
        connectedObject?.contentTypeName === 'prop' ||
        connectedObject?.contentTypeName === 'gold-platforms'
    );
};
